import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const LoginScreen = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    studentId: '',
    year: ''
  });
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    if (formData.name && formData.studentId && formData.year && acceptedPrivacy) {
      login(formData);
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <Brain className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Student Wellness</h1>
          <p className="text-gray-600 mt-2">Your mental health companion</p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Student ID</label>
            <input
              type="text"
              name="studentId"
              value={formData.studentId}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Year of Study</label>
            <select
              name="year"
              value={formData.year}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            >
              <option value="">Select year</option>
              <option value="1">1st Year</option>
              <option value="2">2nd Year</option>
              <option value="3">3rd Year</option>
              <option value="4">4th Year</option>
              <option value="postgrad">Postgraduate</option>
            </select>
          </div>

          <div className="space-y-3">
            <label className="flex items-start space-x-3">
              <input
                type="checkbox"
                checked={acceptedPrivacy}
                onChange={(e) => setAcceptedPrivacy(e.target.checked)}
                className="mt-1"
              />
              <span className="text-sm text-gray-600">
                I accept the privacy policy and understand my data will be stored locally on this device
              </span>
            </label>
            
            <button
              type="button"
              onClick={() => setShowPrivacy(!showPrivacy)}
              className="text-sm text-blue-600 hover:underline"
            >
              View Privacy Policy
            </button>

            {showPrivacy && (
              <div className="bg-gray-50 p-4 rounded-lg text-sm text-gray-600 max-h-40 overflow-y-auto">
                <h4 className="font-semibold mb-2">Privacy Policy</h4>
                <ul className="space-y-1 list-disc list-inside">
                  <li>All data is stored locally on your device</li>
                  <li>No data is sent to external servers</li>
                  <li>You can export or delete your data anytime</li>
                  <li>Data is encrypted using device security</li>
                  <li>We never share your information</li>
                </ul>
              </div>
            )}
          </div>

          <button
            onClick={handleSubmit}
            disabled={!acceptedPrivacy || !formData.name || !formData.studentId || !formData.year}
            className={`w-full py-3 rounded-lg font-medium transition-colors ${
              acceptedPrivacy && formData.name && formData.studentId && formData.year
                ? 'bg-blue-600 text-white hover:bg-blue-700' 
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;